import { useEffect, useState } from "react";
import { loadUserPerDayPerHourSalary } from "../ShiftEarnings/shiftEarningsApi";

// Rate auto-fill for the Pay Inputs Add / Edit forms, same rule as Shift
// Earnings: looks up the employee's per-day / per-hour pay rate and fills
// Rate from whichever one matches Basis ("hours" -> per hour, otherwise per
// day). It runs again when the employee, payroll cycle, date or basis
// changes. `enabled` is false for entries whose rate must not change
// (attendance-sourced entries on Edit). A failed lookup leaves Rate as it is.
export const useSalaryRateAutofill = ({ domain, enabled, userId, payScheduleId, date, basis, setForm }) => {
  const [salaryRates, setSalaryRates] = useState(null);

  useEffect(() => {
    setSalaryRates(null);
    if (!enabled || !userId) return undefined;
    const controller = new AbortController();
    loadUserPerDayPerHourSalary(domain, { userId, payScheduleId, date, signal: controller.signal })
      .then((data) => { if (!controller.signal.aborted && data) setSalaryRates(data); })
      .catch(() => {});
    return () => controller.abort();
  }, [enabled, domain, userId, payScheduleId, date]);

  useEffect(() => {
    if (!salaryRates || !enabled) return;
    const rate = basis === "hours" ? salaryRates.per_hour : salaryRates.per_day;
    if (rate != null) setForm((current) => (current ? { ...current, rate: String(rate) } : current));
  }, [salaryRates, basis, enabled, setForm]);
};
